import React from 'react'
import { withApollo } from 'react-apollo'
import { Field } from 'react-final-form'
import MaskedInput from 'react-text-mask'
import classNames from 'classnames'
import CPF from 'gerador-validador-cpf'

import { checkCPFAvailabilityQuery } from '../../../lib/graphql/people'

const mask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
]

const validateInput =
  (client, checkAvailability) => async (value, allValues, meta) => {
    if (value && checkAvailability && meta.dirty && CPF.validate(value)) {
      const {
        data: {
          checkCPFAvailability: { isAvailable, isAvailableOnUFFS, ldapUser },
        },
      } = await client.query({
        query: checkCPFAvailabilityQuery,
        variables: { cpf: value },
        fetchPolicy: 'network-only',
      })

      if (!isAvailable) {
        if (!isAvailableOnUFFS) {
          return `
            CPF já cadastrado no <a href="https://id.uffs.edu.br">idUFFS</a> com o nome de usuário: ${ldapUser.uid}!<br/>
            Por favor, utilizar esse cadastro para acesso à rede!
          `
        }

        return 'Número de CPF já cadastrado!'
      }
    }
  }

const CPFInput = ({
  name,
  label,
  helpText,
  client,
  checkAvailability,
  ...props
}) => (
  <Field name={name} validate={validateInput(client, checkAvailability)}>
    {({ input, meta }) => (
      <div className="field">
        {label && <label className="label">{label}</label>}

        <div className="control">
          <MaskedInput
            mask={mask}
            {...input}
            render={(ref, inputProps) => (
              <input
                {...props}
                {...inputProps}
                className={classNames('input', {
                  'is-danger': meta.touched && meta.error,
                })}
                ref={ref}
              />
            )}
          />
        </div>

        {!meta.touched && helpText && <p className="help">{helpText}</p>}

        {meta.touched && meta.error && (
          <div
            className="help is-danger"
            dangerouslySetInnerHTML={{ __html: meta.error }}
          />
        )}
      </div>
    )}
  </Field>
)

export default withApollo(CPFInput)
